import * as React from "react";
import { Box, Chip, Stack, FormControl, FormHelperText, TextField } from "@mui/material";
import { OutlinedContainer } from "./OutlinedContainer";
import { convertToTranslationKeys, ValidationError } from "../../../services/validator";
import { t } from "i18next";

interface IChipFieldProps {
    label: string;
    value?: string[];
    onChange: (values: string[]) => void;
    errors?: ValidationError[];
}

export const ChipField = ({label, value, onChange, errors}: IChipFieldProps) => {
    const [values, setValues] = React.useState<string[]>(value || []);
    const [inputValue, setInputValue] = React.useState('');

    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === ',' && inputValue.trim()) {
            event.preventDefault();
            const newValue = inputValue.trim().replace(',', '');
            if (newValue && !values.includes(newValue)) {
                const newValues = [...values, newValue];
                setValues(newValues);
            }
            setInputValue('');
        } else if (event.key === 'Backspace' && !inputValue && values.length > 0) {
            event.preventDefault();
            const newValues = values.slice(0, -1);
            setValues(newValues);
        }
    };

    const handleDelete = (index: number) => {
        const newValues = values.filter((_, i) => i !== index);
        setValues(newValues);
    };

    React.useEffect(() => {
        onChange(values);
    }, [values]);

    return (
        <FormControl fullWidth variant="outlined" error={!!errors && !!errors.length}>
            <OutlinedContainer label={label}>
                <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1}}>
                    {!!values.length && <Stack direction="row" spacing={0} sx={{display: 'flex', flexWrap: 'wrap', gap: 1}}>
                        {values.map((label, index) => (
                            <Chip 
                                key={index} 
                                label={label} 
                                onDelete={() => handleDelete(index)} 
                            />
                        ))}
                    </Stack>}

                    <Box>
                        <TextField
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyDown={handleKeyDown}
                            placeholder="Type and press comma"
                            variant="standard"
                            InputProps={{
                                disableUnderline: true,
                            }}
                        />
                    </Box>
                </Box>
            </OutlinedContainer>

            {!!errors && !!errors.length &&
                <FormHelperText error>
                    {convertToTranslationKeys(errors).map(e => t(e)).join(', ')}
                </FormHelperText>
            }
        </FormControl>
    );    
}
